<template>
  <div class="container-demographic-map">
    <span class="demographic-map-title">Mapa de distribuição demográfica</span>
    <span v-if="this.days > 0 && !isSearching" class="demographic-map-subtitle">
      Onde mais se fala sobre a cidade nos últimos {{ this.days }} dias
    </span>
    <CustomSkeleton v-if="isSearching" type="map" />
    <div v-if="!isSearching" id="demographic-map" class="demographic-map" />
    
    <span style="margin-top: 20px;" v-if="!isSearching && tourist_spots.length === 0" class="no-data-text"
        >Não há dados para o termo pesquisado.</span
      >
  </div>
</template>

<script>
import L from 'leaflet'
import CustomSkeleton from '@/Shared/CustomSkeleton'
import 'leaflet/dist/leaflet.css'
import 'leaflet.heat'

export default {
  props: {
    isSearching: Boolean,
    tourist_spots: Array,
    days: Number,
  },
  components: {
    CustomSkeleton,
  },
  watch: {
    isSearching: {
      handler(n, o) {
        if (o === true) {
          setTimeout(() => {
            this.createMap()
          }, 1000)
        }
      },
      immediate: true,
    },
  },
  methods: {
    createMap() {
      if (!!document.getElementById('demographic-map')._leaflet_id) {
        document.getElementById('demographic-map')._leaflet_id = null
      }

      const filteredLocation = this.tourist_spots
        .filter((item) => item.mentions > 0)
        .map((item) => [parseFloat(item.lat), parseFloat(item.lng), item.mentions / 100])
      const center =
        filteredLocation.length > 0
          ? [filteredLocation[0][0], filteredLocation[0][1]]
          : [-37.87, 175.475]
      const zoom = 3

      const map = L.map('demographic-map').setView(center, zoom)

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map)

      L.heatLayer(filteredLocation, {
        radius: 25,
        blur: 20,
        maxZoom: 5,
        max: 1,
        minOpacity: 0.4,
        gradient: {
          0.0: 'blue',
          0.2: 'cyan',
          0.4: 'lime',
          0.6: 'yellow',
          0.8: 'orange',
          1.0: 'red',
        },
      }).addTo(map)
    },
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
